import { CardTitle } from '@spa/scenes/Plannings/components'
import type { LabelModel } from '@spa/scenes/Plannings/redux/models/Label'
import React from 'react'
import type { ReactNode, FC } from 'react'

type Props = {
  label: LabelModel
  title?: ReactNode
  className?: string
}
const ShiftLabel: FC<Props> = ({ className, label, title }) => {
  return (
    <CardTitle
      className={className}
      label={title || label?.name}
      color={label?.color}
    />
  )
}

export default ShiftLabel
